import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";


export default function UpdateBrand() {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
const navigate = useNavigate();

  const [uploading, setUploading] = useState(false);

  const [phone, setPhone] = useState("");
  const [id1, setId1] = useState("");
  const [photo, setPhoto] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCategory();
  }, []);
  const getCategory = async () => {
    let data = await Axios.get(`/api/brand/${id}`);
    console.log(data);
    setName(data.data.brand.brandName);
    setTitle(data.data.brand.title);
    setPhone(data.data.brand.photo);
  };

  const submitHandler = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    let brand = { name, title, photo: id1 || phone }; // fallback if photo not re-uploaded
    const { data } = await Axios.put(`/api/brand/${id}`, brand);

    if (data) {
      setLoading(false);
      toast.success("Brand updated successfully 🎉");

      // wait a bit before navigating so toast is visible
      setTimeout(() => {
        navigate("/brands");
      }, 1500);
    }
  } catch (error) {
    setLoading(false);
    toast.error(error.response?.data?.message || "Failed to update brand ❌");
  }
};


  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);
      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", formData, config);
      console.log(data, "dataaaaaaaaaa");
      if (val === "id1") {
        setId1(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Update Brand</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">Brand Name</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  required={true}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputName">Tittle</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">Photo</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "id1")}
                />
              </div>
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    photo === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${photo}`
                  }
                  height="100"
                />
              )}

              {loading ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <div className="bottom-area">
                  <p className="mt-14"></p>
                  <button type="submit" class="btn btn-primary mr-2">
                    Submit
                  </button>
                  <Link to="/brands">
                    <button class="btn btn-light">Cancel</button>
                  </Link>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
